import { render, staticRenderFns } from "./bookDetail.vue?vue&type=template&id=2b6a104c&"
import script from "./bookDetail.vue?vue&type=script&lang=js&"
export * from "./bookDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports